import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { Body1, Body2, borderRadius, colors, fontWeights, H3, Overline, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

export const AudienceLiftContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${borderRadius.lg};
  padding: ${spacing.plusHalf};
  gap: ${spacing.base};
  background: ${colors.backgroundSecondary};
  min-height: ${pxToRem(196)};
  width: 100%;
`;

export const AudienceLiftTitle = styled(Overline)`
  color: ${colors.textSecondary};
`;

export const PrimaryWrapper = styled(FlexSpacer)`
  margin-bottom: ${spacing.threeQuarter};
`;

export const PrimaryNumber = styled(H3)`
  margin: 0;
`;

export const PrimaryText = styled(Body2)`
  margin: 0;
`;

export const SecondaryText = styled(PrimaryText)`
  color: ${colors.textSecondary};
`;

export const PrimaryBoldBody1 = styled(Body1)`
  margin: 0;
  font-weight: ${fontWeights.semiBold};
`;

export const AudienceEngagementMetrics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  min-height: ${pxToRem(120)};
  row-gap: ${spacing.threeQuarter};

  & > p:nth-child(even) {
    text-align: end;
  }

  & > p:nth-child(1),p:nth-child(2) {
    border-bottom: ${spacing.single} solid ${colors.borderPrimary};
    padding-top: 0;
  }

  &[data-rowscount='2'] {
    & > p:nth-child(3) {
      display: flex;
      align-items: center;
    }
    & > p:nth-child(4) {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  
  &[data-rowscount='3'] {
  & > p:nth-child(3),p:nth-child(4) {
      border-bottom: ${spacing.single} solid ${colors.borderPrimary};
      padding-bottom: ${spacing.threeEights};
      padding-bottom: 0;
    }
  }
`;

export const LightColorToolTip = styled(Tooltip)`
  text-decoration-color: ${colors.borderEmphasis};
`;

export const AudienceLiftWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing.base};
  width: 100%;

  @media screen and (width <= 1200px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const BreakdownByMessageTypeWrapper = styled.div`
  @media screen and (width <= 1200px) {
    flex-direction: column;
    overflow-x: scroll;
  }
`;
